import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import { CheckboxField } from 'ksnm-common-ui/lib/Form/CheckboxField';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';

import { usePermission } from '@src/utils/hooks/usePermission';
import { fetchReferences } from '@stores/dictionaryStores/fetchReferences';
import { infoSystemsStore } from '@stores/dictionaryStores/infoSystemStore';
import { reportSettingEditStore } from '@stores/dictionaryStores/reportSettings/reportSettingEditStore';
import { LEVELS } from '@stores/dictionaryStores/reportSettings/reportSettingsStore';
import { sourceTypesStore } from '@stores/dictionaryStores/sourceTypesStore';

import styles from './FunctionalFields.module.scss';

export const FunctionalFields = observer(() => {
  const { isEditMode } = reportSettingEditStore;
  const { infoSystems } = infoSystemsStore;
  const { sourceTypes } = sourceTypesStore;

  const permissionInfoSystem = usePermission('CmInfoSystem');

  useEffect(() => {
    fetchReferences(['infoSystems', 'sourceTypes']);
  }, []);

  const {
    input: { value: levelId },
  } = useField('levelId');

  return (
    <>
      {levelId === LEVELS.LEVEL1 && (
        <CheckboxField name="newWindow" label="Скрыть вкладку Транзакции" groupStyle disabled={!isEditMode} />
      )}

      <SelectField
        name="infoSystemCode"
        items={infoSystems}
        label="Код информационной системы"
        size="small"
        groupStyle
        allowClear
        showSearch
        disabled={!isEditMode || !permissionInfoSystem.VIEW}
      />
      <CheckboxField
        name="signTcc"
        label="Представление по телекоммуникационным каналам связи через оператора электронного документооборота"
        groupStyle
        disabled={!isEditMode}
      />
      <CheckboxField
        name="signInfoSystem"
        label="Представление через информационные системы"
        groupStyle
        disabled={!isEditMode}
      />
      <TextField
        name="formTcc"
        label="Форматы представления по телекоммуникационным каналам связи через оператора электронного документооборота"
        size="small"
        groupStyle
        maxLength={50}
        disabled={!isEditMode}
        unmask={false}
      />
      <CheckboxField
        name="autoForm"
        label="Автоматическое формирование налоговой отчетности"
        groupStyle
        disabled={!isEditMode}
      />
      <TextField
        name="codeExt"
        label="Внешний код отчета"
        size="small"
        groupStyle
        maxLength={40}
        disabled={!isEditMode}
        unmask={false}
      />
      <SelectField
        name="sourceTypeCode"
        items={sourceTypes}
        label="Код типа источника"
        size="small"
        groupStyle
        allowClear
        showSearch
        disabled={!isEditMode}
      />

      <div className={styles.row}>
        <CheckboxField
          name="arbitraryReport"
          label="Построение произвольных пользовательских отчетов"
          groupStyle
          disabled={!isEditMode}
        />
        <CheckboxField
          name="autoDecodeDetail"
          label="Автоматическая расшифровка и детализация"
          groupStyle
          disabled={!isEditMode}
        />
        <CheckboxField
          name="autoCheckVersion"
          label="Автоматическое сравнение разных версий налоговой отчетности"
          groupStyle
          disabled={!isEditMode}
        />
        <CheckboxField name="dataFiltering" label="Фильтрация данных" groupStyle disabled={!isEditMode} />
        <CheckboxField name="dataSorting" label="Сортировка данных" groupStyle disabled={!isEditMode} />
        <CheckboxField name="dataGrouping" label="Группировка данных" groupStyle disabled={!isEditMode} />
        <CheckboxField name="totalCalc" label="Расчет итогов" groupStyle disabled={!isEditMode} />
        <CheckboxField name="dataExport" label="Экспорт данных" groupStyle disabled={!isEditMode} />
        <CheckboxField name="dataPrint" label="Вывод данных на печать" groupStyle disabled={!isEditMode} />
        <CheckboxField
          name="fulltextSearchRus"
          label="Полнотекстовый поиск на русском языке"
          groupStyle
          disabled={!isEditMode}
        />
      </div>
    </>
  );
});
